/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:28:36
 * @LastEditTime: 2022-07-12 13:27:05
 */
import Vue from "vue";
import "ant-design-vue/dist/antd.css";
import router from "./router";
import element from "element-ui";
import store from "./store";
import Antd from "ant-design-vue";
import "./styles/common.less";
import App from "./App.vue";
import API from "@/api/index.js";
import Common from "@/components/Common"
import mixin from "@/mixin"

window.VUE_APP_BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_BASE_URL
    : window.location.origin;
Vue.prototype.$API = API;
Vue.use(element);
Vue.use(Antd);
Vue.component('Common',Common);
Vue.mixin(mixin)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
